<template><div><h1>vux2 和 Vue 官方 webpack 模板区别是什么？</h1>
<p><code>vux2</code> 模板 fork 自 <code>webpack</code> 模板并进行了配置，和 <code>webpack</code> 模板基本同步，因此建议直接使用 vux2 模板。</p>
</div></template><script>
export default {
  head: {"title":"vux2 和 Vue 官方 webpack 模板区别是什么？ | VUX - Vue 移动端 UI 组件库","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// difference-between-vux-template-and-webpack-template-12.vue?7b9f80cc